export const getNotificationIcon = (type: string): string => {
  switch (type) {
    case 'pattern_published':
    case 'material_contribution_approved':
    case 'material_link_suggestion_approved':
    case 'material_link_confirmed':
      return '✅'
    case 'pattern_rejected':
    case 'material_contribution_rejected':
    case 'material_link_suggestion_rejected':
      return '❌'
    case 'pattern_pending_review':
    case 'material_link_suggestion_pending':
      return '⏳'
    case 'material_link_confirmation_needed':
      return '🔗'
    case 'material_link_auto_accepted':
      return '⏰'
    case 'review_received':
      return '⭐'
    case 'follow':
      return '👤'
    case 'pattern_favorited':
      return '❤️'
    case 'follow_new_pattern':
    case 'collection_pattern_added':
      return '🎆'
    case 'collection_followed':
      return '📚'
    case 'system_announcement':
      return '📣'
    case 'system':
      return '📢'
    default:
      return '🔔'
  }
}
